import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsMockAtsService {
  public readonly REDIRECT_URI = `${environment.SERVER_ENDPOINT}/api/services/sponge/mock_ats/callback`;

  constructor() {}

  public generateOAuthLink(credentials: any): string {
    const params = new URLSearchParams({
      client_id: credentials.client_id,
      redirect_uri: this.REDIRECT_URI,
      response_type: 'code',
      scope: 'candidates:read candidates:write',
      state: credentials.hiring_firm_id
    });

    return `http://localhost:3001/oauth/authorize?${params.toString()}`;
  }
}
